export default "__VITE_ASSET__BJUZr1ln__"